<template>
  <button
    v-if="isAbout"
    class="font-semibold rounded-full px-2 focus:outline-none hover:bg-black hover:text-white"
    @click="utilityClicked"
  >
    About
  </button>
  <button v-else class="my-3 ml-3" @click="utilityClicked">
    Terms of use and Privacy
  </button>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  props: {
    isAbout: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  mounted() {
    const firstView = localStorage.getItem("aboutOverlay");
    if (!firstView) {
      if (!this.getAbout) this.clickTimeout();
      else this.utilityClicked(true);
      localStorage.setItem("aboutOverlay", true);
    }
  },
  computed: {
    ...mapGetters(["getIsMobile", "getAbout", "getTermsOfUse"]),
  },
  methods: {
    ...mapMutations(["setOverlay"]),
    clickTimeout() {
      setTimeout(() => {
        if (!this.getAbout) this.clickTimeout();
        else this.utilityClicked(true);
      }, 2000);
    },
    utilityClicked() {
      console.log(this.isAbout);
      const obj = {
        active: true,
        title: this.isAbout ? "About" : "Terms of use",
        content: this.isAbout ? this.getAbout : this.getTermsOfUse,
      };
      this.setOverlay(obj);
    },
  },
};
</script>
